import { HelpCircle } from 'lucide-react';
import { useTour } from './tour-provider';

export function HelpButton() {
  const { startTour } = useTour();

  return (
    <button
      type="button"
      onClick={startTour}
      aria-label="Restart guided tour"
      className="fixed bottom-6 right-6 z-50 flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 text-white shadow-lg hover:bg-indigo-700 transition-colors"
    >
      <HelpCircle className="h-5 w-5" />
    </button>
  );
}
